module.exports = __webpack_public_path__ + "static/media/tictactoe.1908a107.gif";